// ChecklistItemService.tsx
import { BaseService } from '../../core/BaseService';
import { ChangeStatusRequest, PaginationParams } from '../../type';
import {
  ChangeStatusChecklistItemResponse,
  ChecklistItemRequest,
  ChecklistItemResponse,
  DeleteChecklistItemResponse,
  GetChecklistItemByIdResponse,
  GetChecklistItemResponse,
} from './interface';

export class ChecklistItemProfile extends BaseService {
  async createChecklistItem(req: ChecklistItemRequest) {
    return this.post<ChecklistItemResponse, ChecklistItemRequest>(`${this.apiUrl}/api/checklistitems`, req);
  }

  async getChecklistItem(params: PaginationParams, id?: number) {
    return this.get<GetChecklistItemResponse>(`${this.apiUrl}/api/checklistitems/bychecklistid/${id}`, params);
  }

  async updateChecklistItem(id: number, req: ChecklistItemRequest) {
    return this.put<ChecklistItemResponse, ChecklistItemRequest>(`${this.apiUrl}/api/checklistitems/${id}`, req);
  }

  async deleteChecklistItem(id: number) {
    return this.delete<DeleteChecklistItemResponse>(`${this.apiUrl}/api/checklistitems/${id}`);
  }

  async ChangeStatusChecklistItem(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<ChangeStatusChecklistItemResponse, ChangeStatusRequest>(
      `${this.apiUrl}/api/checklistitems/${active}/${id}`,
      req
    );
  }

  async getChecklistItemById(id: number | undefined) {
    return this.get<GetChecklistItemByIdResponse>(`${this.apiUrl}/api/checklistitems/${id}`);
  }
}
